import { Fragment, useState } from 'react';
import { useRouter } from 'next/router';
import { useViewport } from 'hooks/3catinfo/useViewport';
import { getDataUTC } from '@portal-internet/core';
import { getUrlFriendly } from 'components/3catinfo/Enllac/RouteResolver';
import { getHora } from 'utils/3catinfo/dateHelper';
import { getDirecteByTipus } from 'utils/canals';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import Etiqueta from 'components/3catinfo/Etiqueta';
import Text from 'components/3catinfo/Text';
import EtiquetesEspecial from 'components/3catinfo/EtiquetesEspecial';
import Icona from 'components/3catinfo/ui/Icona/Icona';
import Players from 'components/3catinfo/Players';
import styles from './destacatminut.module.scss';
import __get from 'lodash/get';
import __isEmpty from 'lodash/isEmpty';
import __isUndefined from 'lodash/isUndefined';
import clsx from 'clsx';

const MediaDestacat = (props) => {
    const {
        canalDirecte,
        imatges,
        priorityImage,
        id,
        titol,
        numColumnsRow,
        mostrarImatge,
        autoplay = false,
        etiquetaEspecial,
        agrupacions,
        tags
    } = props;
    const [videoActive, setVideoActive] = useState(true);

    const pushMediaModel = (mediaModel) => {
        const duradaMediaModel =
            __get(mediaModel, 'attributes.informacio.attributes.arafem.attributes.durada.text') ||
            __get(mediaModel, 'attributes.informacio.attributes.arafem.durada.text');
        const geoBlocked = __get(mediaModel, 'attributes.geoblocked');
        setVideoActive(duradaMediaModel !== '' && !geoBlocked);
    };

    if (canalDirecte && videoActive) {
        const autoplayBool = String(autoplay).toLowerCase() === 'true';
        return (
            <div className={styles.mediaVideo} data-testid='destacat-video-directe'>
                {etiquetaEspecial && (
                    <div className={styles.etiquetaEspecialWrapperVideoEmbedat}>
                        <EtiquetesEspecial agrupacions={agrupacions} tags={tags} id={id} />
                    </div>
                )}
                <Players
                    id={canalDirecte}
                    tipus='video-directe'
                    autoPlay={autoplayBool}
                    mostrarBotonsAccessibilitat={false}
                    eliminarPrimerTabIndex={true}
                    pushMediaModel={pushMediaModel}
                    imatges={imatges}
                    tagIdPrefix={props.redlAuxInfo?.replaceAll('|', '-')?.toLowerCase() || 'destacat-minut'}
                />
            </div>
        );
    } else {
        return (
            <>
                {etiquetaEspecial && (
                    <div className={styles.etiquetaEspecialWrapper}>
                        <EtiquetesEspecial agrupacions={agrupacions} tags={tags} id={id} />
                    </div>
                )}
                {mostrarImatge && (
                    <Enllac
                        route={{
                            type: 'web_actualitat_item_minutaminut',
                            id: id,
                            slug: titol
                        }}
                        ariaLabel={titol}
                    >
                        <div className={styles.imatge}>
                            <Imatge
                                imatges={imatges}
                                numColumnsRow={numColumnsRow}
                                tipus='web_destacat'
                                aria-hidden='true'
                                layout='fill'
                                objectFit='cover'
                                priority={priorityImage}
                            />
                        </div>
                    </Enllac>
                )}
            </>
        );
    }
};

const Capcalera = (props) => {
    const { titol, autors, lloc, mostraEtiqueta = true } = props;
    const router = useRouter();

    return (
        <>
            {mostraEtiqueta && (
                <Etiqueta
                    className={styles.labelEtiqueta}
                    text='En directe'
                    icona='directes'
                    isBlanc={true}
                    tipus='highlight'
                    size='size-S'
                />
            )}
            <div className={styles.capcalera}>
                <h2 className={styles.titol}>
                    <span dangerouslySetInnerHTML={{ __html: titol }}></span>
                </h2>
                {(!__isEmpty(autors) || !__isEmpty(lloc)) && (
                    <div className={styles.autorWrapper}>
                        {!__isEmpty(autors) && (
                            <span className={styles.autors}>
                                {autors.map((item, i) => {
                                    const isFirst = i === 0 && autors.length > 1;
                                    const isLast = i === autors.length - 1;
                                    const routeAutor = {
                                        slug: item?.nom,
                                        id: item?.id,
                                        tipologia: item?.tipologia
                                    };
                                    const href = getUrlFriendly({
                                        producte: 'web_noticies',
                                        ...routeAutor
                                    });
                                    return (
                                        <Fragment key={'autor-' + item.id}>
                                            {!isLast && !isFirst && ', '}
                                            {isLast && autors.length > 1 && ' i '}
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    if (href) router.push(href);
                                                }}
                                                className={styles.enllacAutor}
                                            >
                                                {item.nom}
                                            </button>
                                        </Fragment>
                                    );
                                })}
                            </span>
                        )}
                        {!__isEmpty(lloc) && <span className={styles.lloc}>{lloc}</span>}
                    </div>
                )}
            </div>
        </>
    );
};

const Entrades = (props) => {
    const { entrades } = props;
    return (
        <>
            <h3 className={styles.titolMinut}>Minut a minut</h3>
            {!__isEmpty(entrades) && (
                <ul className={styles.wrapperMinut}>
                    {entrades.slice(0, 4).map((item, i) => {
                        return (
                            <li key={`itemMinut-${item.id}`}>
                                <span>
                                    <time dateTime={getDataUTC(item.data_publicacio)}>{getHora(item.data_publicacio)}</time>
                                </span>
                                <Text text={item.titol} tag='p' />
                            </li>
                        );
                    })}
                </ul>
            )}
            <div className={styles.wrapperBoto}>
                <div className={styles.botoMinut}>
                    Ves-hi ara
                    <Icona icona='fletxa_dreta' className={styles.iconaBotoMinut} inline={true} alt='' />
                </div>
            </div>
        </>
    );
};

const DestacatMinut = (props) => {
    const {
        titol,
        imatges,
        id,
        entrades,
        numColumnsRow = 0,
        directes,
        priorityImage,
        marcatgeAudienciesClick,
        autors,
        lloc,
        playerEmbedat = false,
        amagarImatge = false,
        principal = false,
        etiquetaEspecial = false
    } = props;
    const playerEmbedatBool = String(playerEmbedat).toLowerCase() === 'true';
    const etiquetaEspecialBool = String(etiquetaEspecial).toLowerCase() === 'true';
    const canalDirecte = playerEmbedatBool && getDirecteByTipus(directes);
    const { zoomNavigator, viewport, typesViewport } = useViewport();

    const stylesDestacat = clsx(
        styles.destacatMinut,
        (parseInt(numColumnsRow) >= 8 || principal) && styles.principal,
        parseInt(numColumnsRow) === 8 && styles.column8,
        parseInt(numColumnsRow) === 12 && styles.column12,
        parseInt(numColumnsRow) === 3 && styles.column3,
        parseInt(numColumnsRow) === 4 && styles.column4,
        zoomNavigator > 3 && styles.ambZoom,
        !!canalDirecte && styles.isDirecte,
        amagarImatge && styles.amagarImatge
    );

    if (!titol) {
        return <></>;
    }

    if (
        (parseInt(numColumnsRow) === 12 &&
            canalDirecte &&
            [typesViewport.VP_REGULAR, typesViewport.VP_LARGE].includes(viewport)) ||
        (parseInt(numColumnsRow) === 3 && canalDirecte && typesViewport.VP_SMALL === viewport)
    ) {
        return (
            <div className={stylesDestacat} role='article'>
                <div className={styles.cos}>
                    <div className={styles.columnesDirecteVideo}>
                        <div className={styles.columnaDirecteVideo}>
                            <Enllac
                                route={{
                                    type: 'web_actualitat_item_minutaminut',
                                    id: id,
                                    slug: titol
                                }}
                                marcatgeAudienciesClick={marcatgeAudienciesClick}
                            >
                                <Capcalera titol={titol} id={id} autors={autors} lloc={lloc} />
                            </Enllac>
                        </div>
                        <div className={`${styles.columnaDirecteVideo} ${styles.columnaMediaVideo}`}>
                            <MediaDestacat
                                canalDirecte={canalDirecte}
                                imatges={imatges}
                                priorityImage={priorityImage}
                                {...props}
                                etiquetaEspecial={etiquetaEspecialBool}
                            />
                        </div>
                    </div>

                    <div className={styles.entradesVideo}>
                        <Enllac
                            route={{
                                type: 'web_actualitat_item_minutaminut',
                                id: id,
                                slug: titol
                            }}
                            marcatgeAudienciesClick={marcatgeAudienciesClick}
                        >
                            <Entrades titol={titol} id={id} entrades={entrades} />
                        </Enllac>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className={stylesDestacat} role='article'>
                <div className={styles.cos}>
                    <MediaDestacat
                        canalDirecte={canalDirecte}
                        imatges={imatges}
                        priorityImage={priorityImage}
                        mostrarImatge={!amagarImatge}
                        {...props}
                        etiquetaEspecial={etiquetaEspecialBool}
                    />
                    <Enllac
                        route={{
                            type: 'web_actualitat_item_minutaminut',
                            id: id,
                            slug: titol
                        }}
                        marcatgeAudienciesClick={marcatgeAudienciesClick}
                    >
                        <div className={styles.wrapper}>
                            <div className={styles.wrapperColumn}>
                                <Capcalera titol={titol} id={id} autors={autors} lloc={lloc} mostraEtiqueta={!amagarImatge} />
                            </div>
                            <div className={styles.wrapperColumn}>
                                <Entrades titol={titol} id={id} entrades={entrades} />
                            </div>
                        </div>
                    </Enllac>
                </div>
            </div>
        );
    }
};

export default DestacatMinut;
